module.exports = __webpack_public_path__ + "img/safe-info-ghs.846122bd.svg";